/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseConsumptionOverviewDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListDailyNotificationSendActivityDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListNotificationDeliveryStatsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListNotificationSendActivityDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseObject } from '../backend/model';
/**
 * CouncilReportApi - axios parameter creator
 * @export
 */
export const CouncilReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption report for a specific council
         * @param {string} councilId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [groupBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionReport: async (councilId: string, startDate?: string, endDate?: string, groupBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getConsumptionReport', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/reports/consumption`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['groupBy'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve daily time-series statistics showing notification counts grouped by date rather than by user. This endpoint forwards requests to the admin backend notification service.
         * @summary Get daily notification send activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyNotificationSendActivityReport: async (councilId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getDailyNotificationSendActivityReport', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/reports/daily-notification-send-activity`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get device performance report for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePerformanceReport: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getDevicePerformanceReport', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/reports/device-performance`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve daily notification delivery statistics from the notification_daily_stats table, grouped by channel (EMAIL/PUSH). Includes unique alarm-user pairs count for cross-channel comparison.
         * @summary Get notification delivery daily stats for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date (inclusive, format: yyyy-MM-dd)
         * @param {GetNotificationDeliveryDailyStatsChannelEnum} [channel] Filter by channel (EMAIL or PUSH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDeliveryDailyStats: async (councilId: string, startDate?: string, endDate?: string, channel?: GetNotificationDeliveryDailyStatsChannelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getNotificationDeliveryDailyStats', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/reports/notification-delivery-daily`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve comprehensive statistics about user notifications including email and push notification metrics with pagination and filtering options. This endpoint forwards requests to the admin backend notification service.
         * @summary Get notification and activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {number} [userId] 
         * @param {string} [platform] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSendActivityReport: async (councilId: string, startDate?: string, endDate?: string, userId?: number, platform?: string, page?: number, pageSize?: number, sort?: string, direction?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getNotificationSendActivityReport', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/reports/notification-send-activity`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilReportApi - functional programming interface
 * @export
 */
export const CouncilReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilReportApiAxiosParamCreator(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption report for a specific council
         * @param {string} councilId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [groupBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsumptionReport(councilId: string, startDate?: string, endDate?: string, groupBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConsumptionOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsumptionReport(councilId, startDate, endDate, groupBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilReportApi.getConsumptionReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve daily time-series statistics showing notification counts grouped by date rather than by user. This endpoint forwards requests to the admin backend notification service.
         * @summary Get daily notification send activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListDailyNotificationSendActivityDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyNotificationSendActivityReport(councilId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilReportApi.getDailyNotificationSendActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get device performance report for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevicePerformanceReport(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevicePerformanceReport(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilReportApi.getDevicePerformanceReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve daily notification delivery statistics from the notification_daily_stats table, grouped by channel (EMAIL/PUSH). Includes unique alarm-user pairs count for cross-channel comparison.
         * @summary Get notification delivery daily stats for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date (inclusive, format: yyyy-MM-dd)
         * @param {GetNotificationDeliveryDailyStatsChannelEnum} [channel] Filter by channel (EMAIL or PUSH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationDeliveryDailyStats(councilId: string, startDate?: string, endDate?: string, channel?: GetNotificationDeliveryDailyStatsChannelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListNotificationDeliveryStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationDeliveryDailyStats(councilId, startDate, endDate, channel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilReportApi.getNotificationDeliveryDailyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve comprehensive statistics about user notifications including email and push notification metrics with pagination and filtering options. This endpoint forwards requests to the admin backend notification service.
         * @summary Get notification and activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {number} [userId] 
         * @param {string} [platform] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, userId?: number, platform?: string, page?: number, pageSize?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListNotificationSendActivityDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationSendActivityReport(councilId, startDate, endDate, userId, platform, page, pageSize, sort, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilReportApi.getNotificationSendActivityReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilReportApi - factory interface
 * @export
 */
export const CouncilReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilReportApiFp(configuration)
    return {
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption report for a specific council
         * @param {string} councilId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [groupBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsumptionReport(councilId: string, startDate?: string, endDate?: string, groupBy?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConsumptionOverviewDTO> {
            return localVarFp.getConsumptionReport(councilId, startDate, endDate, groupBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve daily time-series statistics showing notification counts grouped by date rather than by user. This endpoint forwards requests to the admin backend notification service.
         * @summary Get daily notification send activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListDailyNotificationSendActivityDTO> {
            return localVarFp.getDailyNotificationSendActivityReport(councilId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get device performance report for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePerformanceReport(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseObject> {
            return localVarFp.getDevicePerformanceReport(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve daily notification delivery statistics from the notification_daily_stats table, grouped by channel (EMAIL/PUSH). Includes unique alarm-user pairs count for cross-channel comparison.
         * @summary Get notification delivery daily stats for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date (inclusive, format: yyyy-MM-dd)
         * @param {GetNotificationDeliveryDailyStatsChannelEnum} [channel] Filter by channel (EMAIL or PUSH)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDeliveryDailyStats(councilId: string, startDate?: string, endDate?: string, channel?: GetNotificationDeliveryDailyStatsChannelEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListNotificationDeliveryStatsDTO> {
            return localVarFp.getNotificationDeliveryDailyStats(councilId, startDate, endDate, channel, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve comprehensive statistics about user notifications including email and push notification metrics with pagination and filtering options. This endpoint forwards requests to the admin backend notification service.
         * @summary Get notification and activity report for a specific council
         * @param {string} councilId Council identifier
         * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
         * @param {number} [userId] 
         * @param {string} [platform] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, userId?: number, platform?: string, page?: number, pageSize?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListNotificationSendActivityDTO> {
            return localVarFp.getNotificationSendActivityReport(councilId, startDate, endDate, userId, platform, page, pageSize, sort, direction, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilReportApi - object-oriented interface
 * @export
 * @class CouncilReportApi
 * @extends {BaseAPI}
 */
export class CouncilReportApi extends BaseAPI {
    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get consumption report for a specific council
     * @param {string} councilId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [groupBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilReportApi
     */
    public getConsumptionReport(councilId: string, startDate?: string, endDate?: string, groupBy?: string, options?: RawAxiosRequestConfig) {
        return CouncilReportApiFp(this.configuration).getConsumptionReport(councilId, startDate, endDate, groupBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve daily time-series statistics showing notification counts grouped by date rather than by user. This endpoint forwards requests to the admin backend notification service.
     * @summary Get daily notification send activity report for a specific council
     * @param {string} councilId Council identifier
     * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
     * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilReportApi
     */
    public getDailyNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CouncilReportApiFp(this.configuration).getDailyNotificationSendActivityReport(councilId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get device performance report for a specific council
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilReportApi
     */
    public getDevicePerformanceReport(councilId: string, options?: RawAxiosRequestConfig) {
        return CouncilReportApiFp(this.configuration).getDevicePerformanceReport(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve daily notification delivery statistics from the notification_daily_stats table, grouped by channel (EMAIL/PUSH). Includes unique alarm-user pairs count for cross-channel comparison.
     * @summary Get notification delivery daily stats for a specific council
     * @param {string} councilId Council identifier
     * @param {string} [startDate] Start date (inclusive, format: yyyy-MM-dd)
     * @param {string} [endDate] End date (inclusive, format: yyyy-MM-dd)
     * @param {GetNotificationDeliveryDailyStatsChannelEnum} [channel] Filter by channel (EMAIL or PUSH)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilReportApi
     */
    public getNotificationDeliveryDailyStats(councilId: string, startDate?: string, endDate?: string, channel?: GetNotificationDeliveryDailyStatsChannelEnum, options?: RawAxiosRequestConfig) {
        return CouncilReportApiFp(this.configuration).getNotificationDeliveryDailyStats(councilId, startDate, endDate, channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve comprehensive statistics about user notifications including email and push notification metrics with pagination and filtering options. This endpoint forwards requests to the admin backend notification service.
     * @summary Get notification and activity report for a specific council
     * @param {string} councilId Council identifier
     * @param {string} [startDate] Start date for statistics period (inclusive, format: yyyy-MM-dd)
     * @param {string} [endDate] End date for statistics period (inclusive, format: yyyy-MM-dd)
     * @param {number} [userId] 
     * @param {string} [platform] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilReportApi
     */
    public getNotificationSendActivityReport(councilId: string, startDate?: string, endDate?: string, userId?: number, platform?: string, page?: number, pageSize?: number, sort?: string, direction?: string, options?: RawAxiosRequestConfig) {
        return CouncilReportApiFp(this.configuration).getNotificationSendActivityReport(councilId, startDate, endDate, userId, platform, page, pageSize, sort, direction, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetNotificationDeliveryDailyStatsChannelEnum = {
    Email: 'EMAIL',
    Push: 'PUSH'
} as const;
export type GetNotificationDeliveryDailyStatsChannelEnum = typeof GetNotificationDeliveryDailyStatsChannelEnum[keyof typeof GetNotificationDeliveryDailyStatsChannelEnum];
